var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.visible,
        title: "查看",
        "with-header": false,
        "destroy-on-close": true,
        "wrapper-closable": true,
        "close-on-press-escape": false,
        size: "540px",
        direction: "rtl",
        loading: _vm.loading,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "drawerBody overflowOuto",
        },
        [
          _c(
            "div",
            {
              staticClass: "ss-material-box-header",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("div", { staticClass: "ss-material-box-header-title" }, [
                _vm._v("详情"),
              ]),
              _c("i", {
                staticClass: "el-icon-close close",
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              }),
            ]
          ),
          _c("div", { staticClass: "drawerContent overflowOuto" }, [
            _c("div", { staticClass: "problemDetail" }, [
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("画面问题："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.frameQuestion)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("声音问题："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.soundQuestion)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("体验问题："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.userExperienceQuestion)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("问题描述："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.questionDesc)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("版本号："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.version)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("反馈人手机号："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.feedbackPhone)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("反馈时间："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm._f("filterTime")(_vm.detail.createTime))),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("解决状态："),
                ]),
                _c(
                  "div",
                  { staticClass: "problemDetailFormValue" },
                  [
                    _c("MIconStatus", {
                      attrs: {
                        background: _vm.getOptionsValueByKey(
                          "value",
                          "background",
                          _vm.detail.status,
                          _vm.option
                        ),
                        color: _vm.getOptionsValueByKey(
                          "value",
                          "color",
                          _vm.detail.status,
                          _vm.option
                        ),
                        "icon-class": _vm.getOptionsValueByKey(
                          "value",
                          "icon",
                          _vm.detail.status,
                          _vm.option
                        ),
                        title: _vm.getOptionsValueByKey(
                          "value",
                          "label",
                          _vm.detail.status,
                          _vm.option
                        ),
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("处理人："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm.detail.handleUserName)),
                ]),
              ]),
              _c("div", { staticClass: "problemDetailForm" }, [
                _c("div", { staticClass: "problemDetailFormLabel" }, [
                  _vm._v("处理时间："),
                ]),
                _c("div", { staticClass: "problemDetailFormValue" }, [
                  _vm._v(_vm._s(_vm._f("filterTime")(_vm.detail.handleTime))),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }